/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */

const domains = r => {
    return require.ensure( [], () => { 
        r(require('./components/domains/index.vue'))
    }, 'company-bundle');
}

// Routes
export default [
    {
		name: 'company.domains',
		path: '/company/domains',
		component: domains,
    } 
]




// WEBPACK FOOTER //
// ./src/app/company/routes.js